import { CardExpiryElement } from '@stripe/react-stripe-js';
import type { StripeCardExpiryElementChangeEvent } from '@stripe/stripe-js';
import { FieldLabel, Stack } from 'braid-design-system';
import React from 'react';

import type { CreditCardFormValidationErrors } from '../../../../usecases/CreditCard/creditcardTypes';
import FocusRing from '../../../shared/FocusRing';
import TextFieldBox from '../../../shared/TextFieldBox';

import ValidationMesasge from './ValidationMessage';
import { CREDIT_CARD_ELEMENT_OPTIONS } from './elementOptions';

interface Props {
  label: string;
  onInputChange: (
    event: StripeCardExpiryElementChangeEvent,
    id: string,
  ) => void;
  formValidationErrors: CreditCardFormValidationErrors;
}

const CardExpiryInput: React.FC<Props> = ({
  label,
  onInputChange,
  formValidationErrors,
}) => {
  const id = 'card-expiry';
  const [isFocused, setIsFocused] = React.useState(false);
  const errorMessage = formValidationErrors[id];

  return (
    <Stack space="xsmall">
      <FieldLabel label={label} htmlFor={`input-${id}`} />
      <FocusRing isFocused={isFocused}>
        <TextFieldBox
          isFocused={isFocused}
          isInvalid={Boolean(errorMessage)}
          addPadding
        >
          <CardExpiryElement
            id={`input-${id}`}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onChange={(e) => onInputChange(e, id)}
            options={CREDIT_CARD_ELEMENT_OPTIONS}
          />
        </TextFieldBox>
      </FocusRing>
      {errorMessage ? (
        <ValidationMesasge message={errorMessage} field={id} />
      ) : null}
    </Stack>
  );
};

export { CardExpiryInput };
